import { Fragment, useState } from "react";
import { CaretDown, CaretRight, Package } from "@phosphor-icons/react";
import PartsLinesTable, { PartsCountCell } from "@/components/serviceParts/PartsLinesTable";

const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

// Generic expandable report table: one row per job card / advance, part lines underneath.
export default function PartsGroupTable({ rows, columns, rowKey, showAdvance, testPrefix, emptyText }) {
  const [open, setOpen] = useState({});
  const toggle = (k) => setOpen((o) => ({ ...o, [k]: !o[k] }));
  if (!rows.length) {
    return (
      <div className="border border-canvas-line px-3 py-10 text-center text-ink-muted text-xs" data-testid={`${testPrefix}-empty`}>
        <Package size={24} className="mx-auto mb-2 opacity-40" />
        {emptyText}
      </div>
    );
  }
  return (
    <div className="border border-canvas-line overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-canvas-panel border-b border-canvas-line">
          <tr>
            <th className="w-8" />
            {columns.map((c) => <th key={c.label} className="px-3 py-2 font-mono text-[10px] uppercase text-left whitespace-nowrap">{c.label}</th>)}
            <th className="px-3 py-2 font-mono text-[10px] uppercase text-left">Parts</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const k = rowKey(r);
            return (
              <Fragment key={k}>
                <tr
                  onClick={() => toggle(k)}
                  className={`border-b border-canvas-line/50 cursor-pointer hover:bg-canvas-panel transition-colors ${r.parts_overdue ? "border-l-4 border-l-red-500" : ""}`}
                  data-testid={`${testPrefix}-row-${k}`}
                >
                  <td className="px-2 text-ink-muted">{open[k] ? <CaretDown size={14} /> : <CaretRight size={14} />}</td>
                  {columns.map((c) => <td key={c.label} className={`px-3 py-2 ${c.cls || ""}`}>{c.render(r)}</td>)}
                  <td className="px-3 py-2"><PartsCountCell r={r} /></td>
                </tr>
                {open[k] && (
                  <tr className="bg-canvas-panel/60">
                    <td />
                    <td colSpan={columns.length + 1} className="px-3 py-2">
                      <PartsLinesTable lines={r.lines} showAdvance={showAdvance} testPrefix={`${testPrefix}-${k}`} />
                    </td>
                  </tr>
                )}
              </Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export { inr };
